<template>
    <div class="status">
        <span class="status_text" :class="colorstatus">
            {{textstatus}}
        </span>
    </div>

</template>

<script>
export default {
    props: ['status'],
    data(){
        return{
            component_status: Number(this.status),
            textstatus: '',
            colorstatus: '',
        }
    },
    methods: {
        setConfigStatus(){
            if(this.component_status === 0){
                this.textstatus = 'OFFLINE';
                this.colorstatus = 'grey';
            }
            if(this.component_status === 1){
                this.textstatus = 'ONLINE'
                this.colorstatus = 'green';
            }

        }
    },
    mounted() {
        this.setConfigStatus();
    }
}
</script>

<style lang="scss" scoped>
.status{
    display: flex;
    align-items: center;
    .status_text{
        padding: 4px 8px;
        border-radius: 4px;
        border: 1px solid #333;
        color: var(--color-greylight);
        margin-right: 1rem;
        &.grey{
            border-color: #828282;
            color: #fff;
        }
        &.green{
            background: #219653;
            color: #fff;
        }

    }

}
</style>
